import { Component, inject, signal, computed } from '@angular/core';
import { ActivatedRoute, Router } from '@angular/router';
import { MatCardModule } from '@angular/material/card';
import { MatButtonModule } from '@angular/material/button';
import { MatIconModule } from '@angular/material/icon';

@Component({
  selector: 'app-error',
  standalone: true,
  imports: [
    MatCardModule,
    MatButtonModule,
    MatIconModule,
  ],
  template: `
    <mat-card class="error-card">
      <mat-card-header>
        <mat-icon class="error-icon">{{ icon() }}</mat-icon>
        <mat-card-title>{{ title() }}</mat-card-title>
      </mat-card-header>

      <mat-card-content>
        <p>{{ message() }}</p>
      </mat-card-content>

      <mat-card-actions>
        <button mat-raised-button color="primary" (click)="goHome()">
          <mat-icon>home</mat-icon>
          Go Home
        </button>
      </mat-card-actions>
    </mat-card>
  `,
  styles: [`
    .error-card {
      max-width: 480px;
      margin: 4rem auto;
      text-align: center;
      padding: 1rem;
    }
    .error-icon {
      font-size: 48px;
      margin-right: 12px;
    }
  `]
})
export class ErrorComponent {
  private route = inject(ActivatedRoute);
  private router = inject(Router);

  private rawCode = signal<string | null>(null);
  code = computed(() => Number(this.rawCode()) || 500);

  title = computed(() => {
    switch (this.code()) {
      case 404: return 'Page Not Found';
      case 403: return 'Access Denied';
      default: return `Error ${this.code()}`;
    }
  });

  message = computed(() => {
    switch (this.code()) {
      case 404: return 'The page you are looking for does not exist.';
      case 403: return 'You do not have permission to view this page.';
      default: return 'An unexpected error occurred.';
    }
  });

  icon = computed(() => {
    switch (this.code()) {
      case 404: return 'search_off';
      case 403: return 'block';
      default: return 'error';
    }
  });

  constructor() {
    this.route.url.subscribe(segments => {
      const last = segments.at(-1)?.path ?? null;
      this.rawCode.set(last);
    });
  }

  goHome() {
    this.router.navigate(['/']);
  }
}
